import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { MyContext } from '../../context/MyContext';
import { useHistory } from 'react-router-dom';
import { useContext } from 'react';
import green from '@material-ui/core/colors/green';

export default function PaginationButtons(props) {
  let navigate = useHistory();
  const { paginaAtual, setPaginaAtual, paginaTotal, setPaginaTotal } = useContext(MyContext);  
        
  if (Object.values(props)[0] == null) {
    return (<div></div>);
  }
  let _paginaAtual = Object.values(props)[0]; // paginaAtual
  let _paginaTotal = Object.values(props)[1]; // paginaTotal  
  if (_paginaTotal == 0) {
    return (<div></div>);
  }

  const handleChange = (e, numeroPaginaClicada) => {
    setPaginaAtual(numeroPaginaClicada);
    window.scrollTo (0,0); 
  };

  return (
    <Stack spacing={2} sx={{ marginTop: '10px', marginBottom: '10px' }}>
      <div style={{ width: '100%', maxWidth: '100%' }}>
        <Pagination count={paginaTotal}  page={paginaAtual}  defaultPage={paginaAtual} onChange={handleChange} showFirstButton showLastButton color='success' />      
      </div>
    </Stack>
  );
}